
const recaptchaForm = document.querySelectorAll('.j-recaptcha-form')


const googleRecaptcha = (e) => {
	e.preventDefault();
	grecaptcha.ready(function() {
	  grecaptcha.execute('6Ldtk0gfAAAAACPWMoSiKjmoEZ68JbjcdCT9Vqo-', {action: 'submit'}).then(function(token) {
		  // Add your logic to submit to your backend server here.
		  //console.log(e)
		  const tokenField = document.querySelector('.g-recaptcha-token')
		  if(tokenField){
			  tokenField.value = token
			  e.target.submit()
		  }
	  })
	})
}


// init
if (recaptchaForm) {
	recaptchaForm.forEach(function (form) {
		form.addEventListener('submit', googleRecaptcha)
	})
}